import React, { Component } from 'react'
import { listenUsersOnline } from '../../../firebase/database/handleUserMgm'
import { connect } from 'react-redux'
import * as routes from '../../../constants/routes'
import InAppNav from '../../InAppNav/InAppNav'
import DefaultPage from '../../../Container/Layout/DefaultPage'
import List from '../../../Container/Lists/List'
import Loading from '../../../Container/Loading/Loading'
import InputFilter from '../../../Container/Filter/InputFilter'
class UserOnline extends Component{
    constructor(props) {
        super(props);
        this.state = {
            filteredUsers: null,
        };
    }
    async componentDidMount () {
        await listenUsersOnline()
        
    }

    componentWillUnmount () {
        listenUsersOnline(false)
    }


    render () {
       
        const { users } = this.props
        if(users===null) return <Loading text='Daten werden geladen'/>
        return (
            <DefaultPage headline={{headlineText: 'Benutzer online'}}>
                <InAppNav links={[{name:'Admin Home', route: routes.ADMINHOME}]}/>
                <InputFilter
                    initList={users}
                    callback={(filteredUsers)=>this.setState({filteredUsers: filteredUsers })}
                    counter={this.state.filteredUsers!==null ? this.state.filteredUsers.length : null}
                    filterProps={['vorname', 'name', 'ort']}
                    filterActive={this.state.filteredUsers!==null}
                />

               <List 
                    items={this.state.filteredUsers===null ? this.props.users : this.state.filteredUsers}
                    itemHeight={40}
                    headerProps={['Name', 'Ort', 'Email', 'Typ', 'Online']}
                    renderProps={['name', 'ort', 'email', 'role', 'loggedIn']}
                    
                   
                    //buttons= {this.buttonConfig.deactivateUser}
                />
            </DefaultPage>
        )   
    }
}
const mapStateToProps = state => ({
    users: state.adminUserMgm.onlineUsers
})



export default connect(mapStateToProps)(UserOnline)


// WEBPACK FOOTER //
// ./src/Components/Admin/UserMgm/UserOnline.js